import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Paginator } from 'src/app/shared/models/grid.model';

export const LoadPreviewListCols = createAction(
  '[Preview List]: Load Preview List Columns',
  props<{ displayedColumns: { [label: string]: string } }>(),
);

export const PreviewListByFilter = createAction('[Preview List]: Preview List By Filter', props<{ data: any }>());

export const PreviewListByFilterSuccess = createAction(
  '[Preview List]: Preview List By Filter Success',
  props<{ res: any }>(),
);

export const PreviewListByFilterFailed = createAction(
  '[Preview List]: Preview List By Filter Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const PreviewListForMembers = createAction(
  '[Preview List]: Preview List For Members',
  props<{ campaignAdHocListId: number | null }>(),
);

export const PreviewListForMembersSuccess = createAction(
  '[Preview List]: Preview List For Members Success',
  props<{ res: any }>(),
);

export const PreviewListForMembersFailed = createAction(
  '[Preview List]: Preview List For Members Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const PreviewListForPerson = createAction(
  '[Preview List]: Preview List For Person',
  props<{ campaignAdHocListId: number | null }>(),
);

export const PreviewListForPersonSuccess = createAction(
  '[Preview List]: Preview List For Person Success',
  props<{ res: any }>(),
);

export const PreviewListForPersonFailed = createAction(
  '[Preview List]: Preview List For Person Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const NavigateToMember = createAction(
  '[Preview List]: Navigate To Member',
  props<{ loyaltyMemberId: number | null }>(),
);

export const NavigateToMemberSuccess = createAction('[Preview List]: Navigate Member Page Success');

export const NavigateToMemberFailed = createAction(
  '[Preview List]: Navigate Member Page Failed',
  props<{ error: string }>(),
);

export const NavigateToCustomer = createAction(
  '[Preview List]: Navigate To Customer',
  props<{ personId: number | null }>(),
);

export const NavigateToCustomerSuccess = createAction('[Preview List]: Navigate Customer Page Success');

export const NavigateToCustomerFailed = createAction(
  '[Preview List]: Navigate Customer Page Failed',
  props<{ error: string }>(),
);

export const PreviewListPagingChanged = createAction(
  '[Preview List]: Paging Changed',
  props<{ paginator: Paginator; campaignAdHocListId: number | null }>(),
);
